/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import Personas from "../../models/componentModels/Personas";

export function getRelevantUsersBasedOnPersona(
  gridDataForTenantUsers: any[],
  user_persona: Personas
) {
  if (user_persona === Personas.HoneywellAdmin) {
    return gridDataForTenantUsers;
  } else if (user_persona === Personas.TenantAdmin) {
    gridDataForTenantUsers = gridDataForTenantUsers.filter((x: any) =>
      x.roles.some((y: { name: string }) => y.name !== Personas.HoneywellAdmin)
    );
  } else if (user_persona === Personas.DistributorAdmin) {
    gridDataForTenantUsers = gridDataForTenantUsers.filter((x: any) =>
      x.roles.some(
        (y: { name: string }) =>
          y.name !== Personas.HoneywellAdmin && y.name !== Personas.TenantAdmin
      )
    );
  } else if (user_persona === Personas.OrganizationAdmin) {
    gridDataForTenantUsers = gridDataForTenantUsers.filter((x: any) =>
      x.roles.some(
        (y: { name: string }) =>
          y.name !== Personas.HoneywellAdmin &&
          y.name !== Personas.TenantAdmin       )
    );
  } else if (user_persona === Personas.OrganizationUser) {
    gridDataForTenantUsers = gridDataForTenantUsers.filter((x: any) =>
      x.roles.some(
        (y: { name: string }) =>
          y.name !== Personas.HoneywellAdmin &&
          y.name !== Personas.TenantAdmin &&
          y.name !== Personas.DistributorAdmin &&
          y.name !== Personas.OrganizationAdmin
      )
    );
  } else if (user_persona === Personas.NoAccess) {
    gridDataForTenantUsers = [];
  }
  return gridDataForTenantUsers;
}
export default getRelevantUsersBasedOnPersona;
